/** Stable cache key builders for resort resources. */

export const RESORT_CACHE_PREFIX = {
  hotels: "resort:hotels",
  hotelRooms: "resort:hotelRooms",
  roomPlans: "resort:roomPlans",
  availability: "resort:availability",
  reservations: "resort:reservations",
};

export const resortCacheKeys = {
  hotels: () => `${RESORT_CACHE_PREFIX.hotels}:all`,

  hotelRooms: () => `${RESORT_CACHE_PREFIX.hotelRooms}:all`,

  hotelRoomsByHotel: (hotelId) =>
    `${RESORT_CACHE_PREFIX.hotelRooms}:hotel:${hotelId || "all"}`,

  roomPlans: (roomId) =>
    `${RESORT_CACHE_PREFIX.roomPlans}:room:${roomId || "unknown"}`,

  /** Raw reservations dump used when composing availability */
  reservations: () => `${RESORT_CACHE_PREFIX.reservations}:all`,

  availability: ({ hotelId = "", startDate = "", endDate = "" } = {}) =>
    `${RESORT_CACHE_PREFIX.availability}:hotel:${hotelId || "all"}:range:${startDate}:${endDate}`,
};
